var map = {
	"./banner-consultant.jpg": "55e2",
	"./banner-contact.jpg": "6d66",
	"./banner-core.jpg": "255f",
	"./banner-culture.jpg": "2c6a",
	"./banner-direction-swyy.jpg": "6695",
	"./banner-direction-ylfw.jpg": "fbba",
	"./banner-direction-ylqx.jpg": "38de",
	"./banner-direction.jpg": "b1e6",
	"./banner-index-text-s.jpg": "1c3f",
	"./banner-index-text.jpg": "1c77",
	"./banner-index.jpg": "78f8",
	"./banner-intro.jpg": "b741",
	"./banner-news.jpg": "032a",
	"./banner-philosophy.jpg": "175e",
	"./banner-portfolio.jpg": "f6cb",
	"./banner-prize.jpg": "bd62",
	"./banner-risk.jpg": "5439",
	"./banner-standard.jpg": "b963",
	"./banner-study.jpg": "9196",
	"./banner-watch.jpg": "4b71",
	"./icon-addr.png": "a533",
	"./icon-email.png": "b99a",
	"./icon-movie.png": "a93a",
	"./icon-play.png": "7577",
	"./icon-tel.png": "4c81",
	"./img-intro.jpg": "9515",
	"./img-philosophy-1.jpg": "06e9",
	"./img-philosophy-2.jpg": "8123",
	"./img-philosophy-3.jpg": "676d",
	"./img-risk-1.png": "18d2",
	"./img-risk-2.png": "29bd",
	"./img-risk-3.png": "575b",
	"./img-risk-4.png": "a4c1",
	"./img-risk-5.png": "53ba",
	"./img-risk-6.png": "4258",
	"./img-risk.jpg": "81d9",
	"./img-standard-1-txt.jpg": "baac",
	"./img-standard-1.jpg": "701d",
	"./img-standard-2-txt.jpg": "e9df",
	"./img-standard-2.jpg": "609b",
	"./img-standard-3-txt.jpg": "cd16",
	"./img-standard-3.jpg": "4f59",
	"./img-standard-4-txt.jpg": "f906",
	"./img-standard-4.jpg": "9d36",
	"./img-standard.jpg": "c999",
	"./img-video.jpg": "8d94",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";